<template>
  <v-card class="fs-status-card my-5" flat outlined>
    <div class="fs-status-title">{{ work.deviceName || work.name || '—' }}</div>
    <div class="fs-status-chip" :class="statusClass">
      {{ statusLabel }}
    </div>

    <div class="fs-status-row mt-3">
      <v-icon size="16" color="#193546">mdi-account-hard-hat-outline</v-icon>
      <span class="fs-status-text">{{ work.userDisplay || '—' }}</span>
    </div>

    <div class="fs-status-row">
      <v-icon size="16" color="#193546">mdi-map-marker-outline</v-icon>
      <span class="fs-status-text">{{ work.coordinates || '—' }}</span>
    </div>

    <div class="fs-status-row">
      <v-icon size="16" :color="work.hasPluviometricChart ? '#0098E1' : '#8FA3AD'">mdi-file-document-outline</v-icon>
      <span class="fs-status-text">{{ chartLabel }}</span>
    </div>
  </v-card>
</template>

<script>
import { surveyWorkStatusToUi } from '@/lib/surveyWorkStatus'

export default {
  name: 'FieldSurveyStatusCard',
  props: {
    work: {
      type: Object,
      required: true
    }
  },
  computed: {
    uiStatus () {
      return surveyWorkStatusToUi(this.work.status)
    },
    statusLabel () {
      const key = `Audits.FieldSurveyStatus.${this.uiStatus}`
      return this.$te(key) ? this.$t(key) : this.uiStatus
    },
    statusClass () {
      return `status-${this.uiStatus}`
    },
    chartLabel () {
      return this.work.hasPluviometricChart
        ? this.$t('FieldSurveyForm.pluviometricChartYes')
        : this.$t('FieldSurveyForm.pluviometricChartNo')
    }
  }
}
</script>

<style scoped lang="stylus">
.fs-status-card
  border-radius 4px !important
  border 1px solid #ebeff2 !important
  background #ffffff !important
  padding 22px 18px 18px

.fs-status-title
  color #173142
  font-size 2rem
  font-weight 500
  line-height 1.2

.fs-status-chip
  display inline-flex
  margin-top 10px
  padding 4px 10px
  border-radius 3px
  font-size 1rem
  line-height 1.1
  color #6b7b84
  background #f0f3f5

.status-new
  background #efefef
  color #88959c

.status-inProgress
  background #fff2bf
  color #a08000

.status-completed
  background #deffe9
  color #2c8c55

.fs-status-row
  display flex
  align-items center
  gap 12px
  margin-top 8px

.fs-status-text
  color #4f5f67
  font-size 1.04rem
  line-height 1.3
  word-break break-word
</style>



// WEBPACK FOOTER //
// FieldSurveyStatusCard.vue?0d77d89f